import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { InMemoryCacheService } from 'src/app/common';


@Injectable()
export class BillingProductResolver  {
  constructor(private cache: InMemoryCacheService) {}

  async resolve(): Promise<any> {
    this.cache.loading = true;
    try {
      await this.cache.getBillingProducts();
    } finally {
      this.cache.loading = false;
    }
    return "";
  }
}
